import { CircularProgress } from './CircularProgress';

interface StatCardProps {
  value: number | string;
  label: string;
  progress?: number;
  variant: 'sale' | 'rent' | 'customer' | 'city';
}

const variantStyles = {
  sale: { bg: 'bg-primary', ring: '#fff', ringBg: 'rgba(255,255,255,0.25)' },
  rent: { bg: 'bg-accent', ring: '#fff', ringBg: 'rgba(255,255,255,0.25)' },
  customer: { bg: 'bg-orange-500', ring: '#fff', ringBg: 'rgba(255,255,255,0.25)' },
  city: { bg: 'bg-muted-foreground/80 dark:bg-muted', ring: '#9ca3af', ringBg: 'rgba(255,255,255,0.15)' },
};

export function StatCard({ value, label, progress = 65, variant }: StatCardProps) {
  const style = variantStyles[variant];
  return (
    <div className={`${style.bg} rounded-2xl p-5 text-white flex items-center justify-between min-h-[110px] shadow-lg`}>
      <div>
        <div className="text-3xl font-bold">{typeof value === 'number' ? value.toLocaleString() : value}</div>
        <div className="text-sm opacity-90 mt-1">{label}</div>
      </div>
      <CircularProgress value={progress} size={60} strokeWidth={5} color={style.ring} bgColor={style.ringBg} />
    </div>
  );
}
